<template>
    <div class="exhibition">
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.exhibition{
    width: 100%;
    height: 100%;
    background:url("../../assets/img/viewBg.jpg");
    background-size: 100% 100%;
    
}
</style>
